import styled from "styled-components/macro"

export const Container = styled.div`
  display: flex;
  display: inline-flex;
  left: 8px;
  margin-bottom: 8px;
  bottom: 10px;
  padding: 2px 6px;
  font-size: 16px;
  font-weight: 700;
  background: ${({ bg }) => (bg ? bg : "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.24) 100%)")};
  color: ${({ color }) => color};
  /* border-bottom: 0.5px solid ${({ color }) => color}; */
  /* border-top: 0.5px solid ${({ color }) => color}; */
  border-radius: 3px;
  opacity: 0.9;
  z-index: 2;

  &i {
    margin-right: 4px;
  }
`
